import React, { Component } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import ReactHtmlParser from 'react-html-parser'
import Breadcrumbs from '../Breadcrumbs'
// import ReviewRate from '../ProductReviewRate'
import ProductVariantDisplay from '../ProductVariantDisplay'

import './product-detail-info.scss'
import './milkshake.scss'

class ProductDetailInfo extends Component {
    render() {
        // console.log("Data Produk = ", this.props.data)
        // console.log('Cek Slug = ', this.props.data.slug)
        if (this.props.data.slug === 'ellips-milkshake-leave-on-conditioner') {
            return (
                <div>
                    <div className="product-detail-info milkshake">
                        <Container fluid>
                            <Row className="m-0">
                                <Col sm={12} lg={6} className="p-0">
                                    <div className="product-detail-banner-img d-none d-lg-block">
                                        <img
                                            src={this.props.data.image}
                                            alt={
                                                !this.props.data.category.name
                                                    ? ``
                                                    : `Ellip Haircare Products - ${this.props.data.category.name}`
                                            }
                                            className="img-fluid"
                                        />
                                    </div>
                                </Col>
                                <Col sm={12} lg={6} className="p-0">
                                    <Breadcrumbs
                                        data={this.props.breadcrumbs}
                                    ></Breadcrumbs>
                                    <div className="product-detail-container">
                                        <div className="variant-name mont-medium">
                                            <h3>{this.props.data.name}</h3>
                                        </div>
                                        <div className="product-detail-banner-img d-block d-lg-none">
                                            <img
                                                src={this.props.data.image}
                                                alt={
                                                    !this.props.data.category
                                                        .name
                                                        ? ``
                                                        : `Ellip Haircare Products - ${this.props.data.category.name}`
                                                }
                                                className="img-fluid"
                                            />
                                        </div>
                                        <div className="variant-desc-detail mont-regular">
                                            {ReactHtmlParser(
                                                this.props.data.details
                                                    .description1
                                            )}
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </div>
            )
        } else if (this.props.data) {
            return (
                <div>
                    <div className="product-detail-info">
                        <Container fluid>
                            <Row className="m-0">
                                <Col sm={12} lg={6} className="p-0">
                                    <div className="product-detail-banner-img d-none d-lg-block">
                                        <img
                                            src={this.props.data.image}
                                            alt={
                                                !this.props.data.category.name
                                                    ? ``
                                                    : `Ellip Haircare Products - ${this.props.data.category.name}`
                                            }
                                            className="img-fluid"
                                        />
                                    </div>
                                </Col>
                                <Col sm={12} lg={6} className="p-0">
                                    <Breadcrumbs
                                        data={this.props.breadcrumbs}
                                    ></Breadcrumbs>
                                    <div className="product-detail-container">
                                        <div className="subcat-title tracking-in-expand mont-medium">
                                            <h1>
                                                {this.props.data.category.name}
                                            </h1>
                                        </div>
                                        <ProductVariantDisplay
                                            data={
                                                this.props.data.category
                                                    .products
                                            }
                                            parent={
                                                this.props.breadcrumbs[0].slug
                                            }
                                            active={this.props.data._id}
                                        />
                                        <div className="product-detail-banner-img d-block d-lg-none">
                                            <img
                                                src={this.props.data.image}
                                                alt={
                                                    !this.props.data.category
                                                        .name
                                                        ? ``
                                                        : `Ellip Haircare Products - ${this.props.data.category.name}`
                                                }
                                                className="img-fluid"
                                            />
                                        </div>
                                        <div className="variant-name mont-medium">
                                            <h3>{this.props.data.name}</h3>
                                        </div>
                                        <div className="variant-desc-detail mont-regular">
                                            {ReactHtmlParser(
                                                this.props.data.details
                                                    .description1
                                            )}
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </div>
            )
        } else {
            return <div></div>
        }
    }
}

export default ProductDetailInfo
